import { render, staticRenderFns } from "./soil.vue?vue&type=template&id=6e5f9654"
import script from "./soil.vue?vue&type=script&lang=js"
export * from "./soil.vue?vue&type=script&lang=js"
import style0 from "./soil.vue?vue&type=style&index=0&id=6e5f9654&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports